/** @flow */
import { takeLatest, put, call } from "redux-saga/effects";
import http from "@http";
import {
  GetReportingFocusListsDepartmentDefaultReports,
  GetReportingFocusListsDepartmentMyReports,
} from "@modules/reporting/constants/actions";
import actionCreator from "@modules/reporting/actionCreator";
import type { DefaultReports } from "@modules/reporting/reducer/focus-lists/manager/types";

type ReportDataResponse = DefaultReports;

function* onGetReportingFocusListsDepartmentDefaultReports(
  action,
): Generator<*, void, { data: ReportDataResponse }> {
  try {
    const { clientId } = action.payload;

    const response = yield call(
      http.get,
      `/api/v1/focus-lists/client/${clientId}/focus-lists/organisational-unit/default-reports`,
    );

    yield put(actionCreator.GetReportingFocusListsDepartmentDefaultReportsSuccess(response.data));
  } catch (e) {
    yield put(
      actionCreator.GetReportingFocusListsDepartmentDefaultReportsError({
        error: e.message,
      }),
    );
  }
}

function* onGetReportingFocusListsDepartmentMyReports(
  action,
): Generator<*, void, { data: ReportDataResponse }> {
  try {
    const { clientId } = action.payload;

    const response = yield call(
      http.get,
      `/api/v1/focus-lists/client/${clientId}/focus-lists/organisational-unit/my-saved-reports`,
    );

    yield put(actionCreator.GetReportingFocusListsDepartmentMyReportsSuccess(response.data));
  } catch (e) {
    yield put(
      actionCreator.GetReportingFocusListsDepartmentMyReportsError({
        error: e.message,
      }),
    );
  }
}

export default function* reportSaga(): Generator<*, void, void> {
  yield takeLatest(
    GetReportingFocusListsDepartmentMyReports,
    onGetReportingFocusListsDepartmentMyReports,
  );
  yield takeLatest(
    GetReportingFocusListsDepartmentDefaultReports,
    onGetReportingFocusListsDepartmentDefaultReports,
  );
}
